import { createStyled } from '@ori-ui/mui-bundle/system';
import theme from '../theme';
const styled = createStyled({
  defaultTheme: theme
});
export default styled;
//# sourceMappingURL=styled.js.map